import { render, staticRenderFns } from "./SafariMap.vue?vue&type=template&id=4565e5c8&scoped=true"
import script from "./SafariMap.vue?vue&type=script&lang=ts"
export * from "./SafariMap.vue?vue&type=script&lang=ts"
import style0 from "./SafariMap.vue?vue&type=style&index=0&id=4565e5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565e5c8",
  null
  
)

export default component.exports